import { useTheme } from '../../context/ThemeContext';

const Button = ({ children, variant = 'primary', size = 'md', icon: Icon, onClick, disabled, style = {}, type = 'button' }) => {
  const { dark } = useTheme();
  const styles = {
    primary: { background: '#3B82F6', color: '#fff', border: 'none' },
    success: { background: '#10B981', color: '#fff', border: 'none' },
    danger: { background: '#EF4444', color: '#fff', border: 'none' },
    outline: { background: 'transparent', color: dark ? '#94A3B8' : '#475569', border: `1px solid ${dark ? '#475569' : '#D1D5DB'}` },
    ghost: { background: 'transparent', color: dark ? '#94A3B8' : '#475569', border: 'none' },
  };
  const sizes = {
    sm: { padding: '5px 12px', fontSize: 12 },
    md: { padding: '8px 16px', fontSize: 13 },
    lg: { padding: '10px 20px', fontSize: 14 },
  };
  return (
    <button type={type} disabled={disabled} onClick={onClick} style={{
      ...styles[variant], ...sizes[size], borderRadius: 8, fontWeight: 600,
      cursor: disabled ? 'not-allowed' : 'pointer',
      display: 'inline-flex', alignItems: 'center', gap: 6,
      opacity: disabled ? 0.5 : 1, transition: 'all 0.15s', ...style,
    }}>
      {Icon && <Icon size={size === 'sm' ? 13 : 15} />} {children}
    </button>
  );
};

export default Button;
